<template>
    <div class="submissionApplication-manage">
        <Paper class="submissionApplication-manage-paper">
            <el-tabs class="submissionApplication-list-tab-pane" v-model="activeTabs" @tab-click="tabClick" @tab-remove="removeTab">
                <el-tab-pane label="目标提报申请" name="tableList" ref="myPane">
                    <list-layout-paper>
                        <template slot="header-search" class="searchBox">
                            <search-box
                                ref="searchBox"
                                :search-key="config.name"
                                :fields="config.searchFields"
                                :showResetBtn="true"
                                @search-change="tableList.searchList"
                            />
                        </template>
                        <template slot="header-button">
                            <lotsButton type="primary" size="mini" title="新增" v-has="authorityCode.add">
                                <el-dropdown class="list-dropdown" trigger="click">
                                    <span class="el-dropdown-link">
                                        新增<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="submissionApplication-list-dropdown-menu">
                                        <!-- <el-dropdown-item class="dropdown-item" title="新增（需删除）">
                                            <div class="dropdown-item-span" @click="createOpera()">新增（需删除）</div>
                                        </el-dropdown-item> -->
                                        <el-dropdown-item
                                            class="dropdown-item"
                                            v-for="item in goalTypeOptions"
                                            :key="item.applyType"
                                            :title="item.applyTypeName"
                                        >
                                            <div class="dropdown-item-span" @click="createOpera(item)">
                                                {{ item.applyTypeName }}
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </lotsButton>
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="刷新"
                                @click="refresh"
                                plain>
                                <span class="icon iconfont icon-refresh"></span>
                            </lotsButton>
                            <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                                <el-button
                                icon="iconfont icon-list_install"
                                type="primary"
                                size="mini"
                                :title="'列配置'"
                                @click="showColumnConfigDialog"
                                plain />
                            </el-tooltip>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="attendanceRulesSettings"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                :height="tableHeight"
                                :tableData="tableList.totalData"
                                :control="false"
                                :allowRowClick="false"
                                @btn-event="handleActive"
                                @row-db-click="toDetailPage"
                            >
                                <template v-slot:col-append="{ item, row, rIndex }">
                                    <span v-if="['applyCode'].includes(item.prop)">
                                        <lotsButton
                                            @click="toDetailPage(row)"
                                            type="text"
                                            size="mini"
                                            :title="row[item.prop]"
                                        >
                                            {{ row[item.prop] }}
                                        </lotsButton>
                                    </span>
                                    <span v-if="['approvalStatus'].includes(item.prop)">
                                        {{ changeKeyToValue(row, item.prop, item.optionsKey) }}
                                    </span>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                :page-size.sync="tableList.pageSize"
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>

                <!-- 详情页签 -->
                <el-tab-pane
                    class="detail-pane"
                    closable
                    v-for="item in tabList"
                    :key="item.id"
                    :label="item.tagName"
                    :name="String(item.id)"
                >
                    <rulesSettingsForm
                        :ref="'rulesSettingsForm' + item.id"
                        tagName="item.tagName"
                        :data="item"
                        :key="item.tagName"
                        :dictDatas="dictDatas"
                        @createSuccessHandle="createFinish"
                        @mipSuccess="mipSuccess"
                    />
                </el-tab-pane>

            </el-tabs>
        </Paper>

        <!-- 表格列配置弹框 -->
        <column-config
            :pageID="config.name"
            :initColumns="config.columns"
            ref="otpColumnConfig"
            @header-change="config.columns = $event"
        />
    </div>
</template>

<script>
import { ref, reactive, onMounted, getCurrentInstance } from '@vue/composition-api';
import { Message } from 'element-ui';
import searchBox from '@/components/lots/searchBox';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getList, detailApi } from '@/modules/mdm/api/targetModdeules/subMissionApplication.js';
import { config as configStatic } from './config';
import rulesSettingsForm from './form.vue';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import columnConfig from '@/components/lots/columnConfig/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { checkApprovalAuthority } from '@/modules/mdm/utils/flowUtils.js';
import store from '@/store/index';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';

export default {
    name: 'submissionApplication',
    components: {
        Paper,
        searchBox,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        rulesSettingsForm,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 获取Vue实例
        const instance = getCurrentInstance();
        const router = instance ? instance.$router : null;
        const route = instance ? instance.$route : null;

        // 按钮权限
        const authorityCode = reactive(btnAuthority.submissionApplication);
        const config = reactive(configStatic);
        const otpColumnConfig = ref(null);
        // 列表列配置弹窗-打开
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        const activeTabs = ref('tableList');
        // 打开的详情tab页集
        const tabList = ref([]);
        // 删除详情标签
        const removeTab = (tagId) => {
            if (activeTabs.value === tagId) {
                activeTabs.value = 'tableList';
                // 清除URL参数
                if (router) {
                    router.push({ query: {} }).catch(() => {});
                }
            }
            tabList.value = tabList.value.filter(
                (tab) => String(tab.id) !== tagId
            );
        };

        const tabClick = (tabObj) => {
            const currentTab = tabList.value.find(v => v.tagName === tabObj.label);
            if (currentTab) {
                // 更新URL参数
                if (router && currentTab.id) {
                    router.push({ query: { id: currentTab.id } }).catch(() => {});
                } else {
                    router.push({ query: {} }).catch(() => {});
                }
            }
        };

        /**
         * @description: 开详情页通用部分代码
         * @param {Object} data 页面数据对象
         * @param {String} name 页面名称信息
         *  */
        // eslint-disable-next-line complexity
        const newDetailPage = (name, data) => {
            const params = {
                tagName: name,
                ...data
            };
            // 3. 查找是否已存在的标签页
            const existingTab = tabList.value.find(v => v.tagName === name);
            if (!existingTab) {
                if (tabList.value.length >= 5) {
                    return Message.warning('已超出5个详情页，请关闭后重新打开');
                } else {
                    tabList.value.push(params);
                    activeTabs.value = String(params.id);
                }
            } else {
                // 4. 如果已存在，直接切换
                activeTabs.value = String(existingTab.id);
            }

            // 更新URL参数
            if (router && data.id) {
                router.push({ query: { id: data.id } }).catch(() => {});
            } else {
                router.push({ query: {} }).catch(() => {});
            }
        };

        // 获取详情
        const getDetail = (id) => {
            return new Promise((resolve, reject) => {
                detailApi({ id: id }).then(res => {
                    if (+res.code === 0) {
                        resolve(res.data);
                    }
                });
            });
        };

        const createOpera = (row) => {
            newDetailPage('新增目标提报申请' + '-' + row.applyTypeName, row);
        };

        const toDetailPage = (row) => {
            // 列表没有返回单据类型名称，在这里回填增加
            row.applyTypeName = dictDatas.value?.['CRM_GOAL_APPLY_TYPE']?.[row.applyType] ?? '数据匹配不上，未知类型';
            const name = '单号' + '-' + row.applyCode;
            newDetailPage(name, row);
        };

        // 新增/编辑完成后刷新列表
        const createFinish = (data) => {
            // removeTab(String(data.id));
            tableList.getList();
        };

        const searchDataFormat = (condition) => {
            condition.goalTypeCodeSet = condition.goalTypeCodes;
            Reflect.deleteProperty(condition, 'goalTypeCodes');
            Reflect.deleteProperty(condition, 'goalTypeNames');
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };

            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            ...v
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getList // 查询接口
            },
            pageSize: 20
        });

        // 操作项
        const handleActive = (row, event) => {
            // 编辑
            // if (event === 'edit') {
            // }
            // // 删除
            // if (event === 'delete') {
            // }
        };

        // 刷新列表
        const refresh = () => {
            tableList.getList();
        };

        // 字典值转换为字典标签
        const changeKeyToValue = (row, prop, optionsKey) => {
            return dictDatas.value[optionsKey]?.[row[prop]] ?? null;
        };

        // 跳转详情页
        const toDetailTab = (res) => {
            setTimeout(() => {
                toDetailPage(res);
            }, 100);
        };

        const dictDatas = ref({});
        const goalTypeOptions = ref([]);
        onMounted(async() => {
            const dictKeys = [
                'CRM_GOAL_APPLY_TYPE' // 单据类型
            ];
            dictDatas.value = await otherUtils.getDictDataList(config.columns, dictKeys);
            const goalApplyTypeDict = dictDatas.value['CRM_GOAL_APPLY_TYPE'];
            if (goalApplyTypeDict && typeof goalApplyTypeDict === 'object') {
                goalTypeOptions.value = Object.entries(goalApplyTypeDict).map(([applyType, applyTypeName]) => ({
                    applyTypeName,
                    applyType
                }));
            }
            tableList.getList();
            // 检查URL参数，如果存在id则自动打开对应的详情页
            if (route && route.query.id) {
                const id = route.query.id;
                const { userCode } = store.getters.user;
                getDetail(id).then((res) => {
                    // 如果userRoleFlag=true，说明当前用户是 总部销售管理、IT管理员
                    if (res?.userRoleFlag) {
                        toDetailTab(res);
                        return;
                    }

                    // 填报主表的单据所有人=自己的
                    if (res?.createUserCode === userCode) {
                        toDetailTab(res);
                        return;
                    }

                    // 填报主表的部门=自己部门的（当前用户在LCRM的组织架构），能看
                    if (res?.authDeptCodeList && res?.authDeptCodeList.length && res?.authDeptCodeList.includes(res?.deptCode)) {
                        toDetailTab(res);
                        return;
                    }

                    // 最后再检查单据关联审批流程相关节点是否包含自己（前端自己调iflow接口），能看
                    if (res?.applyFlow?.mipId) {
                        const fdId = res?.applyFlow?.mipId;
                        const loginName = userCode;
                        checkApprovalAuthority(fdId, loginName).then(isAuth => {
                            if (isAuth) {
                                toDetailTab(res);
                            }
                        });
                    }
                });
            }
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
        });

        // mip审批回显对应数据
        const mipData = ref({});
        const currentTime = ref('');
        const mipSuccess = (data) => {
            mipData.value = data;
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
            // 保留原有逻辑
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipData.value.mipUrl);
            // 向当前组件下的 iframe 发送消息
            const formRef = setupContext.refs['rulesSettingsForm' + activeTabs.value];
            if (formRef && formRef[0] && formRef[0].$refs.mipIframe) {
                const iframe = formRef[0].$refs.mipIframe;
                iframe.contentWindow.postMessage('mbpm_getApprovalData', mipData.value.mipUrl);
            }
        };

        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            const params = prepareApproveParams(event.data);
            handleApproveProcess(params);
        };

        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/mod/mdm/submission-application?id=${mipData.value.applyId}&fdId=${mipData.value.mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };

        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const timer = 1200;
                    setTimeout(async () => {
                        setupContext.root.$nextTick(() => {
                            setupContext.refs['rulesSettingsForm' + activeTabs.value][0].getDetail(mipData.value.applyId);
                        });
                        createFinish();
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
            });
        };

        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };

        return {
            tableList,
            config,
            handleActive,
            activeTabs,
            tabList,
            removeTab,
            tabClick,
            createOpera,
            createFinish,
            authorityCode,
            showColumnConfigDialog,
            otpColumnConfig,
            refresh,
            goalTypeOptions,
            changeKeyToValue,
            toDetailPage,
            dictDatas,
            mipSuccess
        };
    }
};
</script>

<style lang="less">
.list-dropdown.el-dropdown {
    color: #fff;
}

.submissionApplication-list-dropdown-menu {
    background-color: #fff;
    .el-dropdown-menu__item.dropdown-item {
        width: auto;
    }
}

.submissionApplication-manage {
    width: 100%;

    .submissionApplication-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .submissionApplication-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .submissionApplication-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.submissionApplication-manage-paper {
        padding: 0px 20px 20px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.submissionApplication-manage-list-dropdown-menu {
    background-color: #fff;
}

.column-config_title {
    font-size: 14px;
}
</style>
